import { render } from "./GroupCustomerDetailsView.vue?vue&type=template&id=3dc57315&ts=true"
import script from "./GroupCustomerDetailsView.vue?vue&type=script&lang=ts"
export * from "./GroupCustomerDetailsView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__